// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"25a177c9","732":"44677a37","977":"67e40c3c"}[chunkId] + ".chunk.js";
};